'use client'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

// Dynamically import Typewriter with no SSR to reduce initial bundle size
const Typewriter = dynamic(() => import('typewriter-effect'), { ssr: false })

export default function TerminalIntro() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const terminalContent = `$ whoami
Full Stack Developer

$ cat info.json
{
  "name": "Mohammad Kaamil Mirza",
  "location": "Hyderabad, India",
  "interests": [
    "Full Stack Development",
    "AI",
    "ML",
    "DevOps",
    "Cloud Computing",
    "Web3",
    "Open Source"
  ],
  "status": "Building awesome things"
}

$ `

  const terminalHeader = (
    <div className="flex items-center gap-2 mb-2 border-b border-green-500/20 pb-2">
      <div className="w-3 h-3 rounded-full bg-red-500"></div>
      <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
      <div className="w-3 h-3 rounded-full bg-green-500"></div>
      <span className="text-sm text-gray-400 ml-2">terminal</span>
    </div>
  )

  return (
    <div className="font-mono bg-gray-900/50 p-4 border-2 border-green-500 rounded-lg">
      {/* SEO-friendly content - visually hidden but readable by bots */}
      <div className="sr-only">
        <h2>About Mohammad Kaamil Mirza - Full Stack Developer</h2>
        <p>Full Stack Developer & Open Source Enthusiast based in San Francisco, CA</p>
        <p>Expertise: Web Development, Software Engineering, System Architecture</p>
        <p>Technologies: React, Next.js, Node.js, TypeScript, JavaScript, Python</p>
        <p>Interests: Web3, AI, Machine Learning, Open Source Development, Cloud Computing</p>
        <p>Currently: Building scalable applications and contributing to open source</p>
        {/* Additional SEO keywords */}
        <div aria-hidden="true">
          <p>Skills: Frontend Development, Backend Development, DevOps, AWS, Docker, Kubernetes</p>
          <p>Skills: React, Next.js, Node.js, TypeScript, JavaScript, Python</p>
          <p>Skills: React Native, Expo, Flutter, Dart, Python, Django, FastAPI, Flask, SQL, PostgreSQL, MySQL, MongoDB, Redis, Elasticsearch, Kibana, Logstash, Filebeat, Metricbeat, Packetbeat, Winlogbeat, Auditbeat, Heartbeat, Journalbeat, Auditd, Sysdig, Prometheus, Grafana, Kibana, Elasticsearch, Logstash, Filebeat, Metricbeat, Packetbeat, Winlogbeat, Auditbeat, Heartbeat, Journalbeat, Auditd, Sysdig, Prometheus, Grafana</p>
          <p>Skills: AWS, Docker, Kubernetes, Terraform, Helm, Jenkins, GitLab CI/CD, GitHub Actions, Azure, Azure DevOps, Azure Kubernetes Service, Azure SQL, Azure Cosmos DB, Azure Blob Storage, Azure Queue Storage, Azure Table Storage, Azure Cosmos DB, Azure Blob Storage, Azure Queue Storage, Azure Table Storage</p>
          <p>Skills: Git, GitHub, GitLab, Bitbucket, Azure DevOps, Azure Repos, Azure Artifacts, Azure Container Registry, Azure Container Instances, Azure Kubernetes Service, Azure App Service, Azure Functions, Azure Logic Apps, Azure Service Bus, Azure Event Grid, Azure Event Hubs, Azure Cosmos DB, Azure Blob Storage, Azure Queue Storage, Azure Table Storage</p>
          <p>Experience: Software Architecture, API Design, Database Design, System Design</p>
          <p>Tools: Git, GitHub, VS Code, Terminal, Linux, Unix</p>
          <p>Portfolio, Personal Website, Developer Blog, Tech Articles</p>
          <p>San Francisco Bay Area, Remote Work, Software Engineer, Web Developer</p>
          <p>Hyderabad, India, Bangalore, India, Pune, India, Mumbai, India</p>
          <p>Ontario, Canada, Toronto, Canada, Vancouver, Canada, Montreal, Canada</p>
          <p>United Kingdom, London, UK, Manchester, UK, Birmingham, UK</p>
          <p>Australia, Sydney, Australia, Melbourne, Australia, Brisbane, Australia</p>
          <p>New York, USA, Los Angeles, USA, Chicago, USA, Houston, USA</p>
          <p>San Diego, USA, San Jose, USA, Washington, USA, Boston, USA</p>
          <p>Seattle, USA, Austin, USA, San Francisco, USA, San Diego, USA</p>
        </div>
      </div>

      {terminalHeader}
      <div className="h-[440px] md:h-[420px] overflow-hidden">
        {!mounted ? (
          <pre className="text-green-400 text-[13px] md:text-sm whitespace-pre leading-6 px-1">
            {terminalContent}<span className="animate-pulse">▋</span>
          </pre>
        ) : (
          <div className="text-green-400 text-[13px] md:text-sm px-1">
            <Typewriter
              options={{
                delay: 20,
                cursor: '▋',
                wrapperClassName: 'text-green-400 whitespace-pre',
              }}
              onInit={(typewriter) => {
                typewriter
                  .typeString('$ whoami')
                  .pauseFor(200)
                  .typeString('\nFull Stack Developer')
                  .pauseFor(300)
                  .typeString('\n\n$ cat info.json')
                  .pauseFor(200)
                  .typeString('\n{')
                  .typeString('\n  "name": "Mohammad Kaamil Mirza",')
                  .typeString('\n  "location": "Hyderabad, India",')
                  .typeString('\n  "interests": [')
                  .typeString('\n    "Full Stack Development",')
                  .typeString('\n    "AI",')
                  .typeString('\n    "ML",')
                  .typeString('\n    "DevOps",')
                  .typeString('\n    "Cloud Computing",')
                  .typeString('\n    "Web3",')
                  .typeString('\n    "Open Source"')
                  .typeString('\n  ],')
                  .typeString('\n  "status": "Building awesome things"')
                  .typeString('\n}')
                  .pauseFor(300)
                  .typeString('\n\n$ ')
                  .start();
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
} 